import { HorizontalBarChartComponent } from '../charts/horizontal-bar-chart-component'
import { CSVProfile } from '../../types'

export class AFTopLocations extends HorizontalBarChartComponent {
 static config = {
  selector: 'afTopLocations',
  controller: AFTopLocations,
  bindings: HorizontalBarChartComponent.config.bindings,
  template: HorizontalBarChartComponent.config.template,
 }

 setProperties() {
  this.onPointClick = this.countryClick
  this.colorPalette = ['#FECA57']
  this.csvHeaders = ['Locations', 'Count', 'Country Code']
 }

 countryClick = key => {
  if (this.locationType === 'countries') {
   this.countryPointClick(key)
  }
 }
}
